import api from '../api'

export default {

  getReps: async () => {
    return api.get('api/reporting/reps');
  },

  repMovements: async (report) => {
    return api.get(`api/reporting/rep-movements?from=${report.from}&to=${report.to}&user_id=${report.user_id}`)
  },

  repOrders: async (report) => {
    return api.get(`api/reporting/rep-orders?from=${report.from}&to=${report.to}&user_id=${report.user_id}`)
  },

  repOrderProducts: async (report) => {
    return api.get(`api/reporting/rep-order-products?from=${report.from}&to=${report.to}&user_id=${report.user_id}`)
  },

  engagements: async (report) => {
    return api.get(`api/reporting/engagements?from=${report.from}&to=${report.to}`)
  },

  palletDamages: async (report) => {
    return api.get(`api/reporting/pallet-damages?from=${report.from}&to=${report.to}`)
  },

  palletDiscrepancies: async (report) => {
    return api.get(`api/reporting/pallet-discrepancies?from=${report.from}&to=${report.to}`)
  },


}
